// extracted by mini-css-extract-plugin
export var compact = "cwnA7";
export var firstRow = "yZwEf";
export var firstRowGap = "U17Yn";
export var firstRowLine = "E9w46";
export var full = "gMHsR";
export var mailListShimmerContainer = "z600g";
export var paddingFirstMessage = "DodVu";
export var paddingMessage = "Yik5g";
export var personaCircle = "PB0l5";
export var personaGap = "YrfbJ";
export var secondRow = "jKeSS";
export var secondRowEndGap = "kcmre";
export var secondRowEndLine = "wU5_s";
export var secondRowGap = "cb24u";
export var secondRowMainLine = "bRjfe";
export var secondRowText = "CJkG0";
export var skeletonContainer = "LmbpH";
export var thirdRow = "MkgNk";
export var thirdRowGap = "Gifxs";
export var thirdRowLine = "wW1xC";